import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';
import { createQueryHook } from '@/lib/adapters/react-query-adapter';

import { localNavigationMenuSchema, type LocalNavigationMenu } from '../schemas/localNavigationMenu.schema';

const getLocalNavigationMenu = httpGetAdapter<LocalNavigationMenu>({
  url: '/v3/usuario/menu',
  schema: localNavigationMenuSchema,
});

export const useLocalNavigationMenu = createQueryHook<LocalNavigationMenu, Error, ['local-navigation-menu']>(
  ['local-navigation-menu'],
  getLocalNavigationMenu
);
